import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Facebook, Instagram, Twitter, Linkedin, CreditCard, Home as HomeIcon, Car, Store, 
  BanknoteIcon, Phone, Mail, MapPin, Shield, Award, CheckCircle2, Building2
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="container mx-auto px-4">
        {/* Features Section */}
        <div className="py-12 border-b border-slate-200">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-start gap-4">
              <div className="bg-[#F7BA45]/10 p-3 rounded-lg">
                <Shield className="h-6 w-6 text-[#F7BA45]" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-2">Güvenli İşlem</h3>
                <p className="text-sm text-slate-600">256-bit SSL sertifikası ile tüm işlemleriniz güvence altında</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-[#F7BA45]/10 p-3 rounded-lg">
                <Award className="h-6 w-6 text-[#F7BA45]" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-2">En İyi Oranlar</h3>
                <p className="text-sm text-slate-600">Türkiye'nin en uygun kredi ve mevduat faiz oranları</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-[#F7BA45]/10 p-3 rounded-lg">
                <CheckCircle2 className="h-6 w-6 text-[#F7BA45]" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-2">Hızlı Onay</h3>
                <p className="text-sm text-slate-600">Kredi başvurunuz 1 saat içinde sonuçlanır</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="py-12 border-b border-slate-200">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <div className="flex items-center gap-2 mb-6">
                <CreditCard size={32} className="text-[#F7BA45]" />
                <span className="text-2xl font-bold text-slate-800">KREDİPARK</span>
              </div>
              <p className="text-slate-600 mb-6">
                Türkiye'nin en kapsamlı kredi ve banka karşılaştırma platformu
              </p>
              <div className="flex items-center gap-4">
                <a 
                  href="https://www.facebook.com/kredipark" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-slate-100 p-2 rounded-lg hover:bg-[#F7BA45]/10 hover:text-[#F7BA45] transition-colors"
                >
                  <Facebook size={20} />
                </a>
                <a 
                  href="https://www.instagram.com/kredipark/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-slate-100 p-2 rounded-lg hover:bg-[#F7BA45]/10 hover:text-[#F7BA45] transition-colors"
                >
                  <Instagram size={20} />
                </a>
                <a 
                  href="https://www.linkedin.com/in/kredipark/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-slate-100 p-2 rounded-lg hover:bg-[#F7BA45]/10 hover:text-[#F7BA45] transition-colors"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-slate-800 mb-4">Ürünler</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/ihtiyac-kredisi" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <HomeIcon size={16} />
                    <span>İhtiyaç Kredisi</span>
                  </Link>
                </li>
                <li>
                  <Link to="/kredi-kartlari" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <Car size={16} />
                    <span>Kredi Kartları</span>
                  </Link>
                </li>
                <li>
                  <Link to="/mevduat" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <Store size={16} />
                    <span>Mevduat</span>
                  </Link>
                </li>
                <li>
                  <Link to="/uzaktan-musteri-edinimi" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <BanknoteIcon size={16} />
                    <span>Banka Müşterisi Ol</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-slate-800 mb-4">Kurumsal</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/hakkimizda" className="text-slate-600 hover:text-[#F7BA45] transition-colors">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/gizlilik-politikasi" className="text-slate-600 hover:text-[#F7BA45] transition-colors">
                    Gizlilik Politikası
                  </Link>
                </li>
                <li>
                  <Link to="/kvkk-aydinlatma-metni" className="text-slate-600 hover:text-[#F7BA45] transition-colors">
                    KVKK Aydınlatma Metni
                  </Link>
                </li>
                <li>
                  <Link to="/cerez-politikasi" className="text-slate-600 hover:text-[#F7BA45] transition-colors">
                    Çerez Politikası
                  </Link>
                </li>
                <li>
                  <Link to="/kullanici-sozlesmesi" className="text-slate-600 hover:text-[#F7BA45] transition-colors">
                    Kullanıcı Sözleşmesi
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-slate-800 mb-4">İletişim</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-slate-600">
                  <MapPin size={16} className="flex-shrink-0 mt-1" />
                  <span>Kuştepe Mah. Mecidiyeköy Yolu Cad. Trump Tower No:12 İç Kapı No: 221 Şişli İstanbul</span>
                </li>
                <li>
                  <a href="tel:02129091133" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <Phone size={16} />
                    <span>0(212) 909 1133</span>
                  </a>
                </li>
                <li>
                  <a href="mailto:iletisim@kredipark.com" className="text-slate-600 hover:text-[#F7BA45] transition-colors flex items-center gap-2">
                    <Mail size={16} />
                    <span>iletisim@kredipark.com</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Company Information and Copyright */}
        <div className="py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <Building2 size={20} className="text-[#F7BA45] flex-shrink-0 mt-1" />
              <div className="space-y-2">
                <p className="font-medium text-slate-800">
                  Technoworks Bilgi Teknolojileri A.Ş.
                </p>
                <p className="text-sm text-slate-600">
                  Mersis No: 833118794400001
                </p>
              </div>
            </div>
            <p className="text-sm text-slate-600 md:text-right">
              © {new Date().getFullYear()} KrediPark. Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;